import React from 'react';

import styles from './Tab.module.css';

const Tab = ({ name, icon, active, quantity, onClick }) => {
  const iconClass = active ? `fas ${icon}` : `far ${icon}`;
  const buttonText = quantity > 0 ? `${name} (${quantity})` : name;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.button} ${active ? styles.active : ''}`}
    >
      <i className={iconClass} />
      {buttonText}
    </button>
  );
};

Tab.defaultProps = {
  active: false,
};

export default Tab;
